module.exports = __webpack_public_path__ + "img/56.55bbe221.jpg";